import { PhoneIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterClientPhoneNumberAddedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterClientPhoneNumberAddedEventProps {
  event: DiscriminatedMatterClientPhoneNumberAddedEvent;
}

export const MatterClientPhoneNumberAddedEvent: React.FC<
  MatterClientPhoneNumberAddedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <PhoneIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          {event.payload.phone_number && (
            <span className="font-medium text-gray-900">
              {event.payload.phone_number}
            </span>
          )}
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Phone Number Added"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
